/* eslint-env browser, es6 */
import m from "mithril";

import { GameController } from "../game-controller";
import { GameStateInProgress } from "../game-state";
import { focusAndScrollInput } from "../utils";
import { BoardView, EmptyBoardView } from "./board";
import { FooterView, HeaderView } from "./header-footer";
import { InputView } from "./input";
import { PausedMessageView } from "./messages";
import { TimerView } from "./timer";
import { WordListView } from "./word-list";

interface GameInProgressViewAttrs {
  state: GameStateInProgress;
}

export class GameInProgressView
  implements m.Component<GameInProgressViewAttrs>
{
  private state: GameStateInProgress;

  constructor(vnode: m.Vnode<GameInProgressViewAttrs>) {
    this.state = vnode.attrs.state;
  }

  oncreate() {
    focusAndScrollInput();
  }

  view(): m.Children {
    return [
      m(HeaderView),
      m(InputView, {
        disabled: this.state.isPaused,
        onInputHook: GameController.onInput,
        onEnterHook: GameController.onEnter,
      }),
      this.state.isPaused
        ? m(EmptyBoardView)
        : m(BoardView, { board: this.state.board }),
      m(TimerView, {
        hookOnToggle: GameController.onToggleTimer,
        hookOnFinish: GameController.finishGame,
      }),
      this.state.isPaused
        ? m(PausedMessageView)
        : m(WordListView, { wordList: this.state.userWordList }),
      m(FooterView),
    ];
  }
}
